export enum RemoteConfigIssue {
  None,
  Warning,
  Error,
}

export class RemoteConfigModel {
  public loadedConfig?: boolean = undefined
  public loadingConfig?: boolean = undefined
  public configError: RemoteConfigIssue = RemoteConfigIssue.None
  public enable_analytics_logging = false
  public show_cpg_tile = true // for hiding during demos
  public netSuiteOrgs: string[] = []
  public bmoIntegrationsWhitelist: string[] = []
  public pushToWalletWhitelist: string[] = []
  public expenseReviewWhitelist: string[] = []
  public enable_astrada_enrollment = false
  public enable_sso_login = false // Allows for SSO login and new login flow to be used
  public enable_sso_login_whitelist: string[] = [] // org IDs that have SSO login enabled
  public enable_mixpanel_analytics = true
  public show_bill_pay_history = false
  public show_new_budgets_table = false
  public show_bill_pay_share_later = false
  public show_new_filters_flyout = true
  public show_pnc_cobrand = false
  public bulk_select_fast_follows = false
  public show_manage_subscription = false
  public show_qbd_tile = false
  public show_brand_redirect = false
  public extendAIWhitelist: string[] = []
  public normalizedMerchantWhitelist: string[] = []
  public qbdWhitelist: string[] = []
  public suggestionsAndPredictionsWhitelist: string[] = []
  public bulk_push_attachments = false
  public show_automated_expense_review: boolean = false
  public show_expense_policy_ai: boolean = false
  public show_expense_policy_ai_whitelist: string[] = []

  public show_bulk_erp_attachments: boolean = false // adding the receipts sync status to the txn table
  public show_auto_expense_report_overhaul: boolean = false // new accounting summary bar
  public show_marketing_cms: boolean = false // marketing iframes on signin and signup pages
  public show_transaction_flyout_revamp: boolean = false // new transaction flyout design
  public accountingStatsHeaderWhitelist: string[] = []
  public show_ai_insights: boolean = false // enable AI Insights page
  public ai_insights_allowlist: string[] = [] // org IDs that have AI Insights enabled
  public show_extend_ai_agent: boolean = false // enable Extend AI Agent
  public show_normalized_merchant: boolean = false // enable Normalized Merchant feature
  public show_suggestions_and_predictions: boolean = false // enable Suggestions and Predictions feature
  public show_sms_settings: boolean = false
  public show_manager_review_rejection_reason: boolean = false // manager review rejections now show reasons

  public chargebee_base_url = ''
  public chargebee_plan_id = ''
  public chargebee_coupon = ''
  public chargebee_start_timestamp = ''

  public static fromResponse(
    response: RemoteConfigResponse,
  ): RemoteConfigModel {
    const model = this.defaultConfig()
    Object.assign(model, response)
    return model
  }

  public static defaultConfig(): RemoteConfigModel {
    return { ...new RemoteConfigModel() }
  }
}

// any keys added above that should not show in the remote config UI should be added here
// TODO: string[] keys are already filtered out in `FeatureFlagger.tsx` since we don't have a way to modify them in the UI
enum RemoteConfigExclusions {
  loadedConfig,
  loadingConfig,
  configError,
}

export type RemoteConfigResponse = Omit<
  RemoteConfigModel,
  keyof RemoteConfigExclusions
>

export type RemoteConfigKeys = keyof RemoteConfigResponse
export const remoteConfigKeys: RemoteConfigKeys[] = Object.keys(
  RemoteConfigModel.defaultConfig(),
).filter((key) => !(key in RemoteConfigExclusions)) as RemoteConfigKeys[]
